import { render } from "./TeamMemberItemBlock.vue?vue&type=template&id=e2f69048&scoped=true"
import script from "./TeamMemberItemBlock.vue?vue&type=script&lang=js"
export * from "./TeamMemberItemBlock.vue?vue&type=script&lang=js"

import "./TeamMemberItemBlock.vue?vue&type=style&index=0&id=e2f69048&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f69048"]])

export default __exports__